export default __webpack_public_path__ + "static/media/aboutBanner.060e6328.jpg";